/**
 * Agent personas + visual accents (design guidelines: pastel chips, never large solid surfaces).
 * Technical ids are stable and come from the backend catalogue.
 */
export const AGENT_META = {
  ORCHESTRATOR: { persona: "OneGate Orchestrator", initials: "OG", classes: "bg-slate-100 text-slate-900 border-slate-200" },
  CONTENT_AGENT: { persona: "Lina", initials: "LI", classes: "bg-orange-50 text-orange-900 border-orange-200" },
  INTELLIGENCE_AGENT: { persona: "Iris", initials: "IR", classes: "bg-sky-50 text-sky-900 border-sky-200" },
  SALES_AGENT: { persona: "Noah", initials: "NO", classes: "bg-emerald-50 text-emerald-900 border-emerald-200" },
  MEETINGS_AGENT: { persona: "Eliott", initials: "EL", classes: "bg-amber-50 text-amber-950 border-amber-200" },
  PROPOSALS_AGENT: { persona: "Gabriel", initials: "GA", classes: "bg-indigo-50 text-indigo-950 border-indigo-200" },
  COMMERCE_AGENT: { persona: "Jade", initials: "JA", classes: "bg-rose-50 text-rose-900 border-rose-200" },
  GATEWAY_TEST: { persona: "Gateway (test)", initials: "GW", classes: "bg-slate-100 text-slate-900 border-slate-200" },
};

export const agentMeta = (agentId) => AGENT_META[agentId] || { persona: agentId || "Système", initials: (agentId || "SY").slice(0, 2).toUpperCase(), classes: "bg-slate-100 text-slate-900 border-slate-200" };

/** Capability tiers: FAST (cheap/quick) -> STANDARD -> ADVANCED. Desaturated semantic accents. */
export const CAPABILITY_CLASSES = {
  FAST: "bg-sky-50 text-sky-900 border-sky-200",
  STANDARD: "bg-emerald-50 text-emerald-900 border-emerald-200",
  ADVANCED: "bg-indigo-50 text-indigo-950 border-indigo-200",
  VISION: "bg-slate-100 text-slate-900 border-slate-200",
  IMAGE: "bg-slate-100 text-slate-900 border-slate-200",
  VIDEO: "bg-slate-100 text-slate-900 border-slate-200",
};

export const STATUS_CLASSES = {
  success: "bg-emerald-50 text-emerald-900 border-emerald-200",
  succeeded: "bg-emerald-50 text-emerald-900 border-emerald-200",
  error: "bg-rose-50 text-rose-900 border-rose-200",
  failed: "bg-rose-50 text-rose-900 border-rose-200",
  skipped: "bg-slate-100 text-slate-900 border-slate-200",
  planned: "bg-amber-50 text-amber-950 border-amber-200",
  running: "bg-sky-50 text-sky-900 border-sky-200",
  queued: "bg-slate-100 text-slate-900 border-slate-200",
  awaiting_approval: "bg-amber-50 text-amber-950 border-amber-200",
};

export const VENDOR_LABELS = { openai: "OpenAI", anthropic: "Anthropic", gemini: "Google" };

/** "emergent:gemini" -> { source: "emergent", vendor: "gemini" } */
export function splitProvider(provider) {
  if (!provider) return { source: null, vendor: null };
  const [source, vendor] = String(provider).includes(":") ? String(provider).split(":") : [null, provider];
  return { source, vendor };
}
